import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import classNames from 'classnames'
import { Typography } from 'shared/ui'
import { ManualAssignmentUserSelect } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/ui/ManualConversationAssignment/ManualAssignmentUserSelect/ManualAssignmentUserSelect'
import type {
  ConversationAssignmentStore,
  SentimentField,
} from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/store/conversationAssignmentStore'
import styles from './styles.module.scss'

type ISentimentAssignmentProps = {
  store: ConversationAssignmentStore
  title: ReactNode
  description?: string
  className?: string
  sentimentField: SentimentField
}

export const SentimentAssignment = observer(
  ({ store, title, description, className, sentimentField }: ISentimentAssignmentProps) => {
    const {
      filteredSmartAssignmentMembers,
      searchValue,
      setSearchValue,
      getSentimentValue,
      updateSentimentAssignment,
    } = store

    const selectedValue = getSentimentValue(sentimentField)
    const selectedItem = filteredSmartAssignmentMembers.find((item) => {
      if (selectedValue === null) {
        return item.id === 0
      }
      return item.id === selectedValue
    })

    const handleValueChange = (userId: number) => {
      updateSentimentAssignment(sentimentField, userId)
    }

    return (
      <div className={classNames(styles.section, className)}>
        <div className={styles.labelContainer}>
          <Typography ariaLabel={'SentimentAssignmentLabel'} variant={'body-md-medium'}>
            {title}
          </Typography>
          {description && (
            <Typography
              ariaLabel={'SentimentAssignmentDescription'}
              variant={'body-md-regular'}
              color='var(--content-primary-tertiary)'
            >
              {description}
            </Typography>
          )}
        </div>
        <div className={styles.selectContainer}>
          <ManualAssignmentUserSelect
            setValue={handleValueChange}
            value={selectedValue}
            items={filteredSmartAssignmentMembers}
            search={searchValue}
            onSearch={setSearchValue}
            selectedItem={selectedItem}
          />
        </div>
      </div>
    )
  }
)
